import { modeLabel, modeShort } from './rules.js';
import { BELOT_MODES } from './types.js';
const next = (s, n) => (s + 1) % n;
export function belotContractLabel(c) {
    const base = modeShort(c.mode);
    return c.mult === 4 ? `${base} ×4` : c.mult === 2 ? `${base} ×2` : base;
}
export function modeRank(mode) {
    return BELOT_MODES.indexOf(mode);
}
export const belotAuction = {
    init({ table, dealer }) {
        return {
            seatCount: table.seatCount,
            teamOf: table.teamOf,
            dealer,
            calls: [],
            high: null,
            mult: 1,
            contraBy: null,
            passes: 0,
            toAct: next(dealer, table.seatCount),
            done: false,
        };
    },
    legalCalls(s, seat) {
        if (s.done || seat !== s.toAct)
            return [];
        const calls = [{ type: 'pass' }];
        const floor = s.high ? modeRank(s.high.mode) + 1 : 0;
        for (const mode of BELOT_MODES.slice(floor))
            calls.push({ type: 'bid', mode });
        if (s.high && s.mult === 1 && s.teamOf[s.high.seat] !== s.teamOf[seat])
            calls.push({ type: 'contra' });
        if (s.high && s.mult === 2 && s.contraBy !== null && s.teamOf[s.high.seat] === s.teamOf[seat]) {
            calls.push({ type: 'recontra' });
        }
        return calls;
    },
    apply(s, seat, call) {
        const calls = [...s.calls, { seat, call }];
        const n = s.seatCount;
        switch (call.type) {
            case 'bid':
                return { ...s, calls, high: { seat, mode: call.mode }, mult: 1, contraBy: null, passes: 0, toAct: next(seat, n) };
            case 'contra':
                return { ...s, calls, mult: 2, contraBy: seat, passes: 0, toAct: next(seat, n) };
            case 'recontra':
                return { ...s, calls, mult: 4, passes: 0, done: true };
            case 'pass': {
                const passes = s.passes + 1;
                const done = s.high === null ? passes >= n : passes >= n - 1;
                return { ...s, calls, passes, done, toAct: done ? s.toAct : next(seat, n) };
            }
        }
    },
    status(s) {
        if (!s.done)
            return { kind: 'open', toAct: s.toAct };
        if (!s.high)
            return { kind: 'passedOut' };
        const c = { taker: s.high.seat, mode: s.high.mode, mult: s.mult };
        return { kind: 'contract', contract: { ...c, label: belotContractLabel(c) } };
    },
    callKey(call) {
        return call.type === 'bid' ? `bid:${call.mode}` : call.type;
    },
    describe(call, _config) {
        switch (call.type) {
            case 'pass':
                return { label: 'Pass', explain: 'Leave it to someone else.' };
            case 'bid': {
                const name = modeLabel(call.mode);
                const explain = call.mode === 'NT'
                    ? 'No trumps: follow suit, nothing cuts. Card points count double, and nothing is declared but the last trick.'
                    : call.mode === 'AT'
                        ? 'All trumps: every suit ranks J 9 A 10 K Q, and you must beat the card led when you follow.'
                        : `${name} is trump. Your side must take more points than the other, or it all goes to them.`;
                return { label: modeShort(call.mode), explain };
            }
            case 'contra':
                return { label: 'Contra', explain: 'Double: you say they will not make it. The winner of the hand takes everything, twice over.' };
            case 'recontra':
                return { label: 'Recontra', explain: 'Redouble: you say you will. The winner takes everything, four times over, and the bidding ends.' };
        }
    },
};
//# sourceMappingURL=auction.js.map